import React from 'react';



export const FORUM_NOTIFICATION_TYPES = [110, 111, 112, 113];

export const PROJECT_NOTIFICATION_TYPES = [120, 121];

export const DOCUMENT_NOTIFICATION_TYPES = [130];



export const returnStatusMap = {

  '-1': 'Overdue',

  '0': 'Pending',

  '1': 'In-Progess',

  '2': 'Blocked',

  '3': 'Completed',

  '4': 'Paused',

};



export const getForumTitle = (notif) =>

  notif?.forum?.title || notif?.forum_title || notif?.table_value || 'a discussion';



export const getForumIdFromNotification = (notif) => {

  if (notif?.forum?.id) return notif.forum.id;

  if (notif?.forum_id) return notif.forum_id;

  if (notif?.table_name === 'DiscussionForums' && notif?.table_id) return notif.table_id;

  return null;

};



export const getTaskIdFromNotification = (notif) =>

  notif?.task?.id ||

  notif?.task?.taskid ||

  notif?.task_id ||

  notif?.taskid ||

  null;



export const getProjectIdFromNotification = (notif) => {

  if (notif?.project?.id) return notif.project.id;

  if (notif?.project_id) return notif.project_id;

  if (notif?.table_name === 'Projects' && notif?.table_id) return notif.table_id;

  return null;

};



export const getProjectTitle = (notif) =>

  notif?.project?.name || notif?.project_title || notif?.table_value || 'a project';



export const getDocumentIdFromNotification = (notif) => {

  if (notif?.document?.id) return notif.document.id;

  if (notif?.document_id) return notif.document_id;

  if (notif?.table_name === 'Documents' && notif?.table_id) return notif.table_id;

  return null;

};



export const getDocumentTitle = (notif) =>

  notif?.document?.document_title ||

  notif?.document?.file_name ||

  notif?.document_title ||

  notif?.table_value ||

  'a document';



export const getNotificationModuleLabel = (notif) => {

  if (notif?.table_name === 'DiscussionForums' || FORUM_NOTIFICATION_TYPES.includes(Number(notif?.type))) {

    return 'Forum';

  }

  if (

    notif?.table_name === 'Documents' ||

    DOCUMENT_NOTIFICATION_TYPES.includes(Number(notif?.type))

  ) {

    return 'Documents';

  }

  if (

    notif?.table_name === 'Projects' ||

    PROJECT_NOTIFICATION_TYPES.includes(Number(notif?.type))

  ) {

    return 'Projects';

  }

  if (notif?.table_name === 'Tasks' || notif?.task) return 'Tasks';

  return 'General';

};



/** Build notification message; returns JSX or plain text. */

export function getNotificationMessage(notif, { plainText = false } = {}) {

  const taskTitle = notif.task?.title || notif.task_title || '';

  const titleForText = taskTitle || 'a task';

  const highlightedTaskName = plainText

    ? titleForText

    : <span style={{ color: '#1976d2', fontWeight: 'bold' }}>{titleForText}</span>;



  const forumTitle = getForumTitle(notif);

  const highlightedForumName = plainText

    ? forumTitle

    : <span style={{ color: '#1976d2', fontWeight: 'bold' }}>{forumTitle}</span>;



  const projectTitle = getProjectTitle(notif);

  const highlightedProjectName = plainText

    ? projectTitle

    : <span style={{ color: '#1976d2', fontWeight: 'bold' }}>{projectTitle}</span>;



  const documentTitle = getDocumentTitle(notif);

  const highlightedDocumentName = plainText

    ? documentTitle

    : <span style={{ color: '#1976d2', fontWeight: 'bold' }}>{documentTitle}</span>;



  const statusLabel = returnStatusMap[notif.table_value] || notif.table_value;



  switch (Number(notif.type)) {

    case 10:

      return plainText

        ? `You have been assigned to task ${titleForText}`

        : <>You have been assigned to task {highlightedTaskName}</>;

    case 20:

      return plainText

        ? `You were tagged in task ${titleForText}`

        : <>You were tagged in task {highlightedTaskName}</>;

    case 30:

      return plainText

        ? `You are an observer for task ${titleForText}`

        : <>You are an observer for task {highlightedTaskName}</>;

    case 40:

      return plainText

        ? `You are a participant in task ${titleForText}`

        : <>You are a participant in task {highlightedTaskName}</>;

    case 50:

      return plainText

        ? `Your task ${titleForText} status changed to ${statusLabel}`

        : <>Your task {highlightedTaskName} status is changed to {statusLabel}</>;

    case 60:

      return plainText

        ? `A new comment was added to task ${titleForText}`

        : <>A new comment was added to task {highlightedTaskName}</>;

    case 70:

      return plainText

        ? `Someone replied to your comment on task ${titleForText}`

        : <>Someone replied to your comment on task {highlightedTaskName}</>;

    case 80:

      return plainText

        ? `You were mentioned in task ${titleForText}`

        : <>You were mentioned in task {highlightedTaskName}</>;

    case 90:

      return plainText

        ? `Task ${titleForText} starts in 2 days`

        : <>Task {highlightedTaskName} is starting in 2 days</>;

    case 100:

      return plainText

        ? `Task ${titleForText} should have started but has not been activated`

        : <>Task {highlightedTaskName} should have started but hasn't been activated</>;

    case 110:

      return plainText

        ? `A new comment was added to discussion ${forumTitle}`

        : <>A new comment was added to discussion {highlightedForumName}</>;

    case 111:

      return plainText

        ? `Someone replied to your comment on discussion ${forumTitle}`

        : <>Someone replied to your comment on discussion {highlightedForumName}</>;

    case 112:

      return plainText

        ? `You were mentioned in discussion ${forumTitle}`

        : <>You were mentioned in discussion {highlightedForumName}</>;

    case 113:

      return plainText

        ? `You were added as a participant on discussion ${forumTitle}`

        : <>You were added as a participant on discussion {highlightedForumName}</>;

    case 120:

      return plainText

        ? `You were added as a member on project ${projectTitle}`

        : <>You were added as a member on project {highlightedProjectName}</>;

    case 121:

      return plainText

        ? `You were added as a moderator on project ${projectTitle}`

        : <>You were added as a moderator on project {highlightedProjectName}</>;

    case 130:

      return plainText

        ? `A document was shared with you: ${documentTitle}`

        : <>A document was shared with you: {highlightedDocumentName}</>;

    default:

      return plainText

        ? (notif.title || notif.message || notif.content || 'Notification')

        : (notif.title || notif.message || notif.content || <>Notification (Type: {notif.type})</>);

  }

}



export function getNotificationTargetPath(notif) {

  const notificationType = Number(notif?.type);

  const forumId = getForumIdFromNotification(notif);

  if (FORUM_NOTIFICATION_TYPES.includes(notificationType) && forumId) {

    return `/forum/detail/${forumId}`;

  }

  const projectId = getProjectIdFromNotification(notif);

  if (PROJECT_NOTIFICATION_TYPES.includes(notificationType) && projectId) {

    return `/task/projectdetails/${projectId}`;

  }

  if (projectId && notif?.table_name === 'Projects') {

    return `/task/projectdetails/${projectId}`;

  }

  const documentId = getDocumentIdFromNotification(notif);

  if (

    (DOCUMENT_NOTIFICATION_TYPES.includes(notificationType) || notif?.table_name === 'Documents') &&

    documentId

  ) {

    return `/documents/details/${documentId}`;

  }

  const taskId = getTaskIdFromNotification(notif);

  if (taskId) return `/task/taskdetails/${taskId}`;

  return null;

}


